import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { checkFont } from '../func';
import { getValueBinding } from '../../shared';
import MinusIcon from '../../Icons/MinusIcon';
import PlusIcon from '../../Icons/PlusIcon';

const ChangeQuantity = (props: any) => {
  const { attributes, width, height, changeInput, data } = props;
  const {
    opacity,
    backgroundColor,
    fontSize,
    fontFamily,
    color,
    iconBackgroundColor,
  } = attributes;

  const {
    value = 0,
    maximum = 0,
    minimum = 0,
    defaultQuantity = 0,
  }: any = getValueBinding(props.id, data, props);

  const [quantity, setquantity] = useState<number>(0);

  const styles = StyleSheet.create({
    wrapper: {
      width,
      height,
      display: 'flex',
      justifyContent: 'center',
    },
    select: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row',
    },
    listItem: {
      marginLeft: 45,
      marginRight: 15,
      marginTop: 10,
      marginBottom: 10,
    },
  });

  const handlePlus = () => {
    if (quantity < +maximum && changeInput) {
      setquantity(quantity + 1);
      changeInput(`${quantity + 1}`);
    }
  };

  const handleMinus = () => {
    if (quantity > +minimum && changeInput) {
      setquantity(quantity - 1);
      changeInput(`${quantity - 1}`);
    }
  };

  useEffect(() => {
    if (changeInput && !quantity) {
      changeInput(`${value ? value : defaultQuantity}`);
      setquantity(+`${value ? value : defaultQuantity}`);
    }
  }, [value, changeInput, defaultQuantity]);

  return (
    <View
      style={{
        opacity,
        width,
        height,
        backgroundColor,
      }}
    >
      <View style={[styles.wrapper]}>
        <View style={[styles.select, { width: '100%' }]}>
          <View style={{ width: 25, height: 25 }}>
            {quantity > +minimum ? (
              <TouchableOpacity onPress={handleMinus} activeOpacity={1}>
                <MinusIcon size={25} backgroundColor={iconBackgroundColor} />
              </TouchableOpacity>
            ) : (
              <MinusIcon
                size={25}
                backgroundColor={iconBackgroundColor}
                opacity={0.4}
              />
            )}
          </View>

          <Text
            style={{
              color,
              fontSize,
              fontWeight: 'bold',
              fontFamily: checkFont(fontFamily),
            }}
            numberOfLines={1}
          >
            {quantity}
          </Text>
          <View style={{ width: 25, height: 25 }}>
            {quantity < +maximum ? (
              <TouchableOpacity onPress={handlePlus} activeOpacity={1}>
                <PlusIcon size={25} backgroundColor={iconBackgroundColor} />
              </TouchableOpacity>
            ) : (
              <PlusIcon
                size={25}
                backgroundColor={iconBackgroundColor}
                opacity={0.4}
              />
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

export default ChangeQuantity;
